export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updatedAt: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'thriller' },
  { name: '剧情', slug: 'drama' },
  { name: '耽美', slug: 'bl' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的私密生活',
    author: '金敏秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20art%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20a%20young%20woman%20with%20long%20dark%20hair%20looking%20thoughtfully%20at%20the%20viewer%2C%20delicate%20linework%2C%20minimalist%20background%20with%20cherry%20blossom%20petals%2C%20manga%20style%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一个普通上班族女孩的秘密双面生活。白天是兢兢业业的职场新人，夜晚却有着不为人知的另一面。当她意外被同事发现这个秘密后，紧张刺激又甜蜜的故事就此展开……',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '职场', '甜宠'],
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    chapters: [
      { id: 'ch-1-1', title: '第1话 秘密的开始', number: 1, updatedAt: '2026-07-20' },
      { id: 'ch-1-2', title: '第2话 意外的相遇', number: 2, updatedAt: '2026-07-22' },
      { id: 'ch-1-3', title: '第3话 心跳加速', number: 3, updatedAt: '2026-07-25' },
      { id: 'ch-1-4', title: '第4话 无法隐藏', number: 4, updatedAt: '2026-07-28' },
      { id: 'ch-1-5', title: '第5话 告白之夜', number: 5, updatedAt: '2026-08-01' },
    ],
    updatedAt: '2026-08-01',
  },
  {
    id: 'comic-2',
    title: '剑与魔法之王国',
    author: '李志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20webtoon%20cover%2C%20epic%20fantasy%20style%20with%20a%20warrior%20holding%20a%20glowing%20sword%2C%20magical%20kingdom%20in%20background%2C%20warm%20golden%20and%20amber%20tones%2C%20dramatic%20lighting%2C%20detailed%20armor%20design%2C%20manhwa%20art%20style%2C%20clean%20minimal%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个被魔法统治的王国里，一个普通少年意外获得了传说中的圣剑。从此，他踏上了拯救王国的冒险之旅，途中结识了各具特色的伙伴，共同对抗黑暗势力的入侵。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '热血'],
    status: '连载中',
    rating: 4.9,
    views: 2560000,
    chapters: [
      { id: 'ch-2-1', title: '第1话 圣剑觉醒', number: 1, updatedAt: '2026-07-15' },
      { id: 'ch-2-2', title: '第2话 踏上旅程', number: 2, updatedAt: '2026-07-18' },
      { id: 'ch-2-3', title: '第3话 精灵之森', number: 3, updatedAt: '2026-07-22' },
      { id: 'ch-2-4', title: '第4话 黑暗降临', number: 4, updatedAt: '2026-07-26' },
      { id: 'ch-2-5', title: '第5话 龙之谷', number: 5, updatedAt: '2026-07-30' },
      { id: 'ch-2-6', title: '第6话 伙伴的力量', number: 6, updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-3',
    title: '都市猎人传说',
    author: '朴正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20thriller%20webtoon%20cover%2C%20dark%20cityscape%20at%20night%2C%20a%20mysterious%20man%20in%20a%20long%20coat%20standing%20on%20a%20rooftop%2C%20dramatic%20shadows%2C%20warm%20amber%20streetlights%2C%20neo-noir%20aesthetic%2C%20clean%20graphic%20illustration%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '在繁华都市的阴影中，有一位专门惩戒邪恶的神秘猎人。前特种兵出身的他，以超凡的身手和敏锐的直觉，在城市的暗处与犯罪组织展开一场场惊心动魄的较量。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '悬疑', '都市'],
    status: '已完结',
    rating: 4.7,
    views: 1890000,
    chapters: [
      { id: 'ch-3-1', title: '第1话 黑夜降临', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch-3-2', title: '第2话 第一个目标', number: 2, updatedAt: '2026-06-05' },
      { id: 'ch-3-3', title: '第3话 追击战', number: 3, updatedAt: '2026-06-10' },
      { id: 'ch-3-4', title: '第4话 真相浮现', number: 4, updatedAt: '2026-06-15' },
      { id: 'ch-3-5', title: '第5话 最终决战', number: 5, updatedAt: '2026-06-20' },
      { id: 'ch-3-6', title: '第6话 新的开始（完）', number: 6, updatedAt: '2026-06-25' },
    ],
    updatedAt: '2026-06-25',
  },
  {
    id: 'comic-4',
    title: '搞笑一家人',
    author: '崔恩熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20comedy%20webtoon%20cover%2C%20a%20quirky%20family%20of%20four%20characters%20with%20exaggerated%20funny%20expressions%2C%20bright%20warm%20colors%20yellow%20and%20orange%2C%20playful%20cartoon%20style%2C%20simple%20clean%20background%2C%20lighthearted%20atmosphere&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一家四口的日常爆笑生活！严厉但可爱的妈妈、憨厚老实的爸爸、调皮捣蛋的儿子和古灵精怪的女儿，每一天都充满了让人捧腹大笑的故事。温馨又搞笑的家庭喜剧。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '日常', '家庭'],
    status: '连载中',
    rating: 4.6,
    views: 950000,
    chapters: [
      { id: 'ch-4-1', title: '第1话 妈妈的秘密食谱', number: 1, updatedAt: '2026-07-10' },
      { id: 'ch-4-2', title: '第2话 爸爸的健身计划', number: 2, updatedAt: '2026-07-14' },
      { id: 'ch-4-3', title: '第3话 儿子的校园风波', number: 3, updatedAt: '2026-07-18' },
      { id: 'ch-4-4', title: '第4话 女儿的才艺表演', number: 4, updatedAt: '2026-07-22' },
    ],
    updatedAt: '2026-07-22',
  },
  {
    id: 'comic-5',
    title: '第七夜的秘密',
    author: '尹智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20mystery%20thriller%20webtoon%20cover%2C%20dark%20atmospheric%20scene%20with%20a%20woman%20looking%20back%20over%20her%20shoulder%2C%20moonlight%20streaming%20through%20a%20window%2C%20deep%20shadowy%20tones%2C%20suspenseful%20mood%2C%20elegant%20illustration%20style%2C%20minimalist%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '一个偏僻小镇上接连发生离奇失踪事件，每第七天的夜晚就会有人消失。女主角作为记者深入调查，却发现每一个线索都指向一个尘封多年的可怕真相……',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '推理', '惊悚'],
    status: '连载中',
    rating: 4.9,
    views: 3100000,
    chapters: [
      { id: 'ch-5-1', title: '第1话 第一个失踪者', number: 1, updatedAt: '2026-07-05' },
      { id: 'ch-5-2', title: '第2话 第七日的规律', number: 2, updatedAt: '2026-07-09' },
      { id: 'ch-5-3', title: '第3话 旧宅的秘密', number: 3, updatedAt: '2026-07-14' },
      { id: 'ch-5-4', title: '第4话 目击者', number: 4, updatedAt: '2026-07-19' },
      { id: 'ch-5-5', title: '第5话 黑暗中的低语', number: 5, updatedAt: '2026-07-24' },
      { id: 'ch-5-6', title: '第6话 真相的碎片', number: 6, updatedAt: '2026-07-29' },
      { id: 'ch-5-7', title: '第7话 第七夜', number: 7, updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-6',
    title: '星光之下',
    author: '韩秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20drama%20romance%20webtoon%20cover%2C%20a%20couple%20sitting%20together%20under%20a%20starry%20night%20sky%2C%20soft%20dreamy%20atmosphere%2C%20warm%20muted%20rose%20and%20navy%20tones%2C%20gentle%20illustration%20style%2C%20romantic%20mood%2C%20clean%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '两个在星光下相遇的灵魂。一个是梦想成为歌手却屡屡受挫的音乐老师，一个是外表冷漠内心温暖的天才作曲家。当他们的命运交织在一起，音乐成为了最美的情书。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '音乐', '成长'],
    status: '已完结',
    rating: 4.8,
    views: 1750000,
    chapters: [
      { id: 'ch-6-1', title: '第1话 不期而遇', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-6-2', title: '第2话 第一个音符', number: 2, updatedAt: '2026-05-07' },
      { id: 'ch-6-3', title: '第3话 和声', number: 3, updatedAt: '2026-05-14' },
      { id: 'ch-6-4', title: '第4话 不协和音', number: 4, updatedAt: '2026-05-21' },
      { id: 'ch-6-5', title: '第5话 星光交响曲（完）', number: 5, updatedAt: '2026-05-28' },
    ],
    updatedAt: '2026-05-28',
  },
  {
    id: 'comic-7',
    title: '花开的声音',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20BL%20romance%20webtoon%20cover%2C%20two%20young%20men%20standing%20close%20together%20in%20a%20flower%20garden%2C%20soft%20sunlight%2C%20delicate%20pastel%20pink%20and%20cream%20tones%2C%20beautiful%20floral%20elements%2C%20gentle%20atmosphere%2C%20clean%20elegant%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在一家花店里，两个截然不同的年轻人相遇了。性格内向的花艺师与阳光开朗的咖啡师，在花香与咖啡香中，一段温柔而深刻的情感悄然绽放。',
    category: '耽美',
    categorySlug: 'bl',
    tags: ['耽美', '治愈', '日常'],
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    chapters: [
      { id: 'ch-7-1', title: '第1话 花店与咖啡', number: 1, updatedAt: '2026-07-12' },
      { id: 'ch-7-2', title: '第2话 向日葵的心意', number: 2, updatedAt: '2026-07-17' },
      { id: 'ch-7-3', title: '第3话 雨天的约定', number: 3, updatedAt: '2026-07-23' },
      { id: 'ch-7-4', title: '第4话 花语', number: 4, updatedAt: '2026-07-30' },
    ],
    updatedAt: '2026-07-30',
  },
  {
    id: 'comic-8',
    title: '异能学院',
    author: '赵勇基',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20webtoon%20cover%2C%20a%20group%20of%20students%20with%20supernatural%20powers%20in%20school%20uniforms%2C%20dynamic%20action%20pose%2C%20energy%20effects%20in%20warm%20golden%20and%20amber%20tones%2C%20anime-inspired%20art%20style%2C%20clean%20dramatic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '在看似普通的高中校园里，隐藏着一个专门培养异能者的秘密班级。拥有各种超能力的学生们在这里学习控制力量，同时也要面对来自暗处的威胁和青春期的烦恼。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '校园', '异能'],
    status: '连载中',
    rating: 4.5,
    views: 820000,
    chapters: [
      { id: 'ch-8-1', title: '第1话 觉醒之日', number: 1, updatedAt: '2026-07-08' },
      { id: 'ch-8-2', title: '第2话 入学测试', number: 2, updatedAt: '2026-07-13' },
      { id: 'ch-8-3', title: '第3话 第一次任务', number: 3, updatedAt: '2026-07-20' },
    ],
    updatedAt: '2026-07-20',
  },
];

export const faqs = [
  {
    question: '奇妙漫画网上的漫画都是免费的吗？',
    answer: '是的！奇妙漫画网所有漫画内容均免费提供在线阅读。我们致力于为广大韩漫爱好者提供无障碍的阅读体验，无需付费订阅即可畅享精彩内容。我们会定期更新新章节，确保您能第一时间看到最新连载。',
  },
  {
    question: '如何在奇妙漫画网上找到我喜欢的韩国漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：在首页的热门推荐和最新更新区域浏览；使用分类功能按恋爱、奇幻、动作等类型筛选；或者直接在搜索框中输入漫画名称或作者名进行搜索。我们还提供个性化推荐，根据您的阅读偏好推送相似作品。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '不同漫画的更新频率有所不同。热门连载漫画通常每周更新1-2话，部分作品可能根据作者排期有所调整。您可以在每部漫画的详情页查看最近更新时间，也可以关注我们首页的最新更新区域获取实时动态。',
  },
  {
    question: '我可以在手机或平板上阅读漫画吗？',
    answer: '当然可以！奇妙漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。页面会自动调整布局，确保漫画画面清晰、文字可读。',
  },
  {
    question: '遇到阅读问题或页面加载失败怎么办？',
    answer: '如果您遇到页面加载缓慢或显示异常的情况，建议先刷新页面尝试。如果问题持续存在，可以通过关于我们页面的联系表单向我们反馈。请尽可能详细描述遇到的问题和使用的设备信息，我们的技术团队会尽快处理。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: '',
    comment: '这个网站真的太棒了！每天通勤路上都会打开看两话，画质清晰加载快，推荐了好多好看的韩漫，已经安利给所有朋友了！',
    rating: 5,
  },
  {
    name: '漫画达人阿杰',
    avatar: '',
    comment: '作为看了十年漫画的老读者，奇妙漫画网的体验真的让我惊艳。分类很全，更新及时，最重要的是完全免费，良心网站！',
    rating: 5,
  },
  {
    name: '莉莉安',
    avatar: '',
    comment: '界面简洁好看，没有烦人的广告弹窗，阅读体验超级流畅。收藏功能特别好用，追更再也不用担心错过更新了。',
    rating: 5,
  },
];